module.exports = __webpack_public_path__ + "img/bag_red.1bc033f6.jpg";